import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.currentPage = this.el.querySelector('.o-anchors-nav_current-page');
        this.related = this.el.querySelector('.o-anchors-nav_related');
        
        this.events = {
            click: {
                toggleRelated: 'toggleRelated'
            }
        }

        document.addEventListener('click', e => {
            if (!this.related) return;
            
            if (this.related.classList.contains('-visible')) {
                if (!this.related.contains(e.target)) this.related.classList.remove('-visible');
            }
        });
    }

    init() {
        // this.updateHeight();

        // window.addEventListener("resize",() => {
        //     this.minHeight = 1;
        //     this.itemsWrap.style.setProperty('--minHeight', this.minHeight + 'px');
        //     this.updateHeight();
        // });
    }

    toggleRelated(e) {
        if (!this.related) return;

        if (this.related.classList.contains('-visible')) {
            this.related.classList.remove('-visible');
        } else {
            this.related.classList.add('-visible');
        }
        e.stopPropagation();
    }
}
